import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        chapterForm: '=',
        material: '=',
        context: '=',
        contentLanguage: '='
    },
    template: `
        <tinymce
            api-url="vm.apiUrl"
            chapter="vm.chapterForm"
            content-language="vm.contentLanguage"
            ng-model="vm.chapterForm.content"
        ></tinymce>
    `
})
export default class {
    constructor (TokenService, $rootScope, $translate, $timeout) {
        this.$rootScope = $rootScope;
        this.TokenService = TokenService;
        this.$translate = $translate;
        this.$timeout = $timeout;

        if (this.context === 'add') {
            if (!this.chapterForm.isOpened) {
                this.chapterForm.isOpened = true;
            }
        }

        this.nameHidden = this.context === 'edit' && this.chapterForm.name;
    }

    $onInit () {
        this.apiUrl = `${SEED_CORE.ENV.API_URL}`;
    }

    getChapterPlaceholder (index) {
        const chapterName = this.$translate.instant('course.materialSource.Chapter');
        return `${chapterName} ${index + 1}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/material/index.js